<template>
      <div class="charts">
            <!-- <img @click="toMaxChart(index,vol)" class="iconMax" src="@/assets/images/icon-max.png" alt="tomax"> -->
            <div :id="'chart'+index" class="chart"></div>
          </div>
</template>
<script>
  import deepcopy from "deepcopy";
export default {
    
    props:["index"],
    data(){
     return{
         
     }
    },
    created(){
        //this.createCharts(this.index)
    },
    methods:{
    createCharts(index, nums, times, sd, ss = 1) {
        var vm = this;
        var myChart;
        if (myChart) myChart.dispose(); //销毁

        myChart = Echarts.init(
          document.getElementById(`chart${index}`),
          "light"
        );
        // 第一次之后,不需要loading
        if (!this.volOptions.length) myChart.showLoading();
        //解决图表左侧空间
        let gLeft = "10%";
        let numsCopy = deepcopy(nums);
        numsCopy = numsCopy.sort(function(a, b) {
          return a - b;
        });
        const maxNum = numsCopy[numsCopy.length - 1] || 0;
        const minNum = numsCopy[0] || 0;
      

        if (maxNum > 999 || maxNum.toString().length > 3) gLeft = "11%";
        if (maxNum > 9999 || maxNum.toString().length > 4) gLeft = "13%";
        if (maxNum > 99999 || maxNum.toString().length > 5) gLeft = "15%";
        if (maxNum > 999999 || maxNum.toString().length > 6) gLeft = "17%";
        if (maxNum > 999999 || maxNum.toString().length > 7) gLeft = "19%";

        setTimeout(() => {
          // 指定图表的配置项和数据
          let linarr = [];
          let oilSiteThreshold = this.volLists[index].oilSiteThreshold;
          if (oilSiteThreshold) {
            if (oilSiteThreshold.topTopLine) {
              linarr.push({
                lineStyle: {
                  //警戒线的样式 ，虚实 颜色
                  type: "dotted", //样式  ‘solid’和'dotted'
                  color: "#f5222d",
                  width: 2, //宽度
                },
                yAxis: oilSiteThreshold.topTopLine,
              })
            }
            if (oilSiteThreshold.topLine) {
              linarr.push({
                lineStyle: {
                  //警戒线的样式 ，虚实 颜色
                  type: "dotted", //样式  ‘solid’和'dotted'
                  color: "#ff9b04",
                  width: 2, //宽度
                },
                yAxis: oilSiteThreshold.topLine,
              })

            }
            if (oilSiteThreshold.bottomBottomLine) {
              linarr.push({
                lineStyle: {
                  //警戒线的样式 ，虚实 颜色
                  type: "dotted", //样式  ‘solid’和'dotted'
                  color: "#f5222d",
                  width: 2, //宽度
                },
                yAxis: oilSiteThreshold.bottomBottomLine
              })

            }
            if (oilSiteThreshold.bottomLine) {
              linarr.push({
                lineStyle: {
                  //警戒线的样式 ，虚实 颜色
                  type: "dotted", //样式  ‘solid’和'dotted'
                  color: "#ff9b04",
                  width: 2, //宽度
                },
                yAxis: oilSiteThreshold.bottomLine,
              }, )
            }
          }
          let option = {
          
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross", //横轴会出现虚线
              },
              position: function(pt) {
                position: ["50%", "50%"];
              },
              textStyle: {
                fontSize: 12,
              },
            },
            textStyle: {
              fontSize: "12px",
              fontWeight: "normal",
            },
            grid: {
              top: "5%",
              left: gLeft,
              right: "5%",
              bottom: "10%",
            },
            xAxis: {
              type: "category",
              boundaryGap: false,
              data: times,
            },
            yAxis: {
              type: "value",
              min: minNum.toFixed(3), //0,
              // max: function (value) {
              //     return (value.max * 1.2).toFixed(1)
              // }
              // axisLine: { onZero: false }
            },
            dataZoom: [{
                type: "inside",
                start: 100,
                end: 95,
                handleSize: "100%",
              },
              {
                show: false,
                start: 100,
                end: 95,
                handleSize: "100%",
              },
            ],
            color: "#5470c6",
            series: [{
              name: this.volLists[index].name,
              data: nums,
              type: "line",
              // symbol: "none",
              smooth: true,
              lineStyle: {
                width: 2,
              },
              markLine: {
                symbol: [
                  'none'
                ], //['none']表示是一条横线；['arrow', 'none']表示线的左边是箭头，右边没右箭头；['none','arrow']表示线的左边没有箭头，右边有箭头
                label: {
                  show: false,
                  position: "middle" //将警示值放在哪个位置，三个值“start”,"middle","end" 开始 中点 结束
                },
                data: linarr
              },
            
            }, ],
          };

          // 动态变量
          // eval("let volOption_" + index + "=" + option)
          if (sd || ss == -1) {

            this.maxVolOptions = option; // max的搜索时间数据
            myChart.hideLoading();
            if (sd || ss == -1) this.toMaxChart(index);
          } else {
            this.volOptions[index] = option;
            myChart.hideLoading();

            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
            myChart.on('datazoom', (params) => {
              this.$debounce(() => { //防抖
                const {
                  end,
                  start
                } = params.batch[0]
          
              }, 300)
            })
          }
        }, 1000);

        this.$store.state.spinShow = false;
      }
    }
}
</script>
<style scoped >
.chart {
    width: 100%;
    height: 241px;
    border: 1px solid red;
}
</style>